export type AddToDashboardButtonProps = {
    isDisabled?: boolean;
    tooltipContent?: string | null;
};
export enum BetaTrafficSource {
    Direct = "Direct",
    Email = "Email",
    Referrals = "Referrals",
    SocialOrganic = "Social - Organic",
    SocialPaid = "Social - Paid",
    OrganicSearch = "Search - Organic",
    PaidSearch = "Search - Paid",
    Display = "Display Ads",
    GenAi = "Gen AI",
}
export interface IBetaTrafficSources {
    [key: string]: number;
    [BetaTrafficSource.Direct]: number;
    [BetaTrafficSource.Email]: number;
    [BetaTrafficSource.Referrals]: number;
    [BetaTrafficSource.SocialOrganic]: number;
    [BetaTrafficSource.SocialPaid]: number;
    [BetaTrafficSource.OrganicSearch]: number;
    [BetaTrafficSource.PaidSearch]: number;
    [BetaTrafficSource.GenAi]: number;
    [BetaTrafficSource.Display]: number;
}
export interface IChannelsBetaData {
    [key: string]: {
        trafficSources: IBetaTrafficSources;
        totalVisits: number;
    };
}
